import React from 'react';
import { useTheme } from 'styled-components';

export const TickSvg = (props) => {
  const { width, height, color, square, filled, circle } = props;

  const theme = useTheme();

  if (filled) {
    return (
      <svg width={width ?? "12"} height={height ?? "9"} viewBox="0 0 12 9" fill={color ?? theme?.colour?.primary ?? "#9EACB0"} xmlns="http://www.w3.org/2000/svg">
        <path d="M4.27041 8.76686C3.96199 8.76847 3.65356 8.65364 3.41581 8.41749L0.357242 5.37674C-0.115037 4.90445 -0.119856 4.13779 0.347604 3.66227C0.815064 3.18513 1.5781 3.18028 2.05199 3.65095L4.25274 5.8377L9.62613 0.361115C10.0952 -0.116024 10.8582 -0.120876 11.3305 0.349793C11.8044 0.82208 11.8092 1.59036 11.3418 2.06426L5.1202 8.40617C4.88566 8.64555 4.57884 8.76524 4.27041 8.76686" />
      </svg>

    )
  }

  if (circle) {
    return (
      <svg width={width ?? "20"} height={height ?? "20"} viewBox="0 0 20 20" fill='none' xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="10" fill={color ?? theme?.colour?.primary ?? "#04333B"} />
        <path d="M9.2485 13.4965C9.0245 13.4965 8.8005 13.4115 8.6295 13.2405L6.2565 10.8675C5.9145 10.5255 5.9145 9.9715 6.2565 9.6305C6.5985 9.2885 7.1515 9.2875 7.4935 9.6295L9.2485 11.3845L13.3765 7.2565C13.7185 6.9145 14.2715 6.9145 14.6135 7.2565C14.9555 7.5985 14.9555 8.1525 14.6135 8.4945L9.8675 13.2405C9.6965 13.4115 9.4725 13.4965 9.2485 13.4965Z" fill="white" />
      </svg>
    )
  }

  if (square) {
    return (
      <svg width={width ?? "25"} height={height ?? "25"} viewBox="0 0 25 25" fill={color ?? theme?.colour?.primary ?? "#1DBD6B"} xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M7.35825 0.625H17.6539C21.6795 0.625 24.3751 3.45125 24.3751 7.655V17.3581C24.3751 21.5487 21.6795 24.375 17.6539 24.375H7.35825C3.33262 24.375 0.625122 21.5487 0.625122 17.3581V7.655C0.625122 3.45125 3.33262 0.625 7.35825 0.625ZM11.8232 16.0506L17.4639 10.41C17.8676 10.0063 17.8676 9.35312 17.4639 8.9375C17.0601 8.53375 16.3951 8.53375 15.9914 8.9375L11.087 13.8419L9.00887 11.7638C8.60512 11.36 7.94012 11.36 7.53637 11.7638C7.13262 12.1675 7.13262 12.8206 7.53637 13.2362L10.3626 16.0506C10.5645 16.2525 10.8257 16.3475 11.087 16.3475C11.3601 16.3475 11.6214 16.2525 11.8232 16.0506Z" />
      </svg>
    )
  }

  return (
    <svg width={width ?? "16"} height={height ?? "16"} viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.3334 1L5.00008 8.33333L1.66675 5" stroke={color ?? "#fff"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}